module.exports = [{
      plugin: require('/Users/thomas/Dev/Freelance/karnott/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
